var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.04876 2.64062L9.77054 12.9654L2 21.3598H3.74884L10.5519 14.0104L16.0486 21.3598H22L13.8438 10.4543L21.0765 2.64062H19.3277L13.0624 9.40935L8.00012 2.64062H2.04876ZM4.62056 3.92882H7.35462L19.4278 20.0714H16.6937L4.62056 3.92882Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterNew);
export default __webpack_public_path__ + "static/media/TwitterNew.3d577575b57aba7364440dbe584dcb6c.svg";
export { ForwardRef as ReactComponent };